import { DatabaseAdd, CheckCircleFill, XCircleFill, ThreeDotsVertical } from "react-bootstrap-icons"
import TableHeader from "../Components/TableHeader"
import { useEffect, useState } from "react"
import core from "../core"
import TableLoader from "../Components/TableLoader"
import OutsideClickHandler from "react-outside-click-handler"
import axios from "axios"
import TableFoot from "../Components/TableFoot"
import AddNewAccount from "../Components/AddNewAccount"
import DialogModal from "../Components/DialogModal"

const Accounts = ({setNotification}) => {
    const query = core.useQuery();
    const [modals, setModals] = useState({createAccount: false, deleteAccount: false});
    const [filter, setFilter] = useState({page: query.page ? query.page : "1", limit: query.limit ? query.limit : "10", keyword: query.keyword ? query.keyword : "", 
        sort_by: query.sort_by ? query.sort_by : "id", sort_order: query.sort_order ? query.sort_order : "DESC", auction: query.auction ? query.auction : ""});
    const [sortBy, setSortBy] = useState([]);
    const [formData, setFormData] = useState({buyer: "", password: "", comment: "", auction: ""})
    const [loading, setLoading] = useState(false);
    const [accounts, setAccounts] = useState([]);
    const [active, setActive] = useState("");
    const checkboxes = [];
    const [action, setAction] = useState("add");
    const [reRender, setReRender] = useState(0);
    const [total, setTotal] = useState(0);
    const [dialog, setDialog] = useState({title: "", text: '', show: "", id: "", loader: false});

    const handlers = {
        addNewHandler(){
            setModals((prev) => ({...prev, createAccount: true}));
            setFormData({buyer: "", password: "", comment: "", auction: ""});
            setAction("add");
        },
        openEditAccountModal(acc){
            setActive("");
            setModals((prev) => ({...prev, createAccount: true}));
            setFormData({
                buyer: acc.buyer, password: acc.password, comment: acc.comment, auction: acc.auction, id: acc.id
            });
            setAction("edit");
        },
        openDeleteAccountModal(acc){
            setDialog({show: true, title: "Delete Account", text: "Do you want to remove this account?", id: acc.id, loader: false});
            setActive("");
        },
        testConnection(acc){
            window.open(acc.auction == "copart" ? `https://copart.com/login?account=${acc.buyer}&type=testconnection` : `https://login.iaai.com/Identity/Account/Login?account=${acc.buyer}&type=testconnection`, "_blank")
        },
        removeAccount(){
            setDialog((prev) => ({...prev, loader: true}));
            axios.delete(`/api/extension/v1/accounts/${dialog.id}`)
                .then((res) => {
                    const data = res.data;
                    setNotification({show: true, type: "success", text: data.message.en});
                    setTimeout(() => {
                        setNotification({show: false, title: "", text: ""});
                    }, 3000);
                    setReRender((prev) => prev + 1);
                    setDialog({show: false, title: "", text: "", id: "", loader: false})
                })
                .catch((err) => {
                    setNotification({show: true, type: "success", text: err.response.data.message.en});
                    setTimeout(() => {
                        setNotification({show: false, title: "", text: ""});
                    }, 3000);
                })
        }
    }

    useEffect(() => {
        axios('/api/extension/v1/options?name=accounts-sort-by')
            .then((res) => {
                const data = typeof res.data == "string" ? JSON.parse(res.data.replace(']P', "]}")) : res.data.data;
                setSortBy(typeof res.data == "string" ? data.data : data);
            })
            .catch((err) => {
                setNotification({show: true, type: "error", text: err.response.data.message.en});
                setTimeout(() => {
                    setNotification({show: false, title: "", text: ""});
                }, 3000);
            })
    }, [])

    useEffect(() => {
        setLoading(true)
        axios(`/api/extension/v1/accounts?page=${filter.page}&limit=${filter.limit}&keyword=${filter.keyword}&sort_by=${filter.sort_by}&sort_order=${filter.sort_order}&auction=${filter.auction}`)
            .then((res) => {
                const data = res.data.data;
                setAccounts(data)
                const count = res.data.total;
                const pageCount = count <= filter.limit ? 1 : (count % filter.limit == 0 ? count / filter.limit : parseInt(count / filter.limit) + 1);
                setTotal(pageCount);
                setLoading(false)
            })
            .catch((err) => {
                setNotification({show: true, type: "error", text: err.response.data.message.en});
                setTimeout(() => {
                    setNotification({show: false, title: "", text: ""});
                }, 3000);
                setLoading(false);
            })
    }, [filter, reRender])

    return(
        <div className="page-content-container">
            <h2 className="page-title">Accounts</h2>
            <TableHeader addNewHandler={handlers.addNewHandler} setNotification={setNotification} AddNewButtonIcon={DatabaseAdd} setModals={setModals} filter={filter} sortBy={sortBy} exportButton={false} checkboxes={checkboxes} setFilter={setFilter} />
            <table className="responsive-d-table">
                <thead>
                    <tr>
                        <th style={{width: "33px"}}><input style={{cursor: "pointer"}} type="checkbox"  onChange={(e) => {
                            if(e.target.checked){

                            }else{

                            }
                        }} /></th>
                        <th>Buyer</th>
                        <th>auction</th>
                        <th>Comment</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        (!loading && accounts.length > 0) && accounts.map((account, id) => {
                            return <tr key={account.id} className={(id + 2) % 2 == 0 ? "even-row" : "odd-row"}>
                                <td><input type="checkbox" /></td>
                                <td>{account.buyer}</td>
                                <td>{account.auction}</td>
                                <td>{account.comment}</td>
                                <td>
                                    <ThreeDotsVertical onClick={() => setActive(account.id)} style={{color: "white", fontSize: "18px", cursor: "pointer"}} />
                                    {active == account.id && <OutsideClickHandler onOutsideClick={() => setActive("")}>
                                        <div className="table-actions-box">
                                            <ul>
                                                <li onClick={() => handlers.openEditAccountModal(account)}>Edit</li>
                                                <li onClick={() => handlers.testConnection(account)}>Test Connection</li>
                                                <li onClick={() => handlers.openDeleteAccountModal(account)}>Delete</li>
                                            </ul>
                                        </div>    
                                    </OutsideClickHandler>}
                                </td>
                            </tr>
                        })
                    }
                    {
                        (!loading && accounts.length == 0) && <tr style={{background: "#494646ff"}}>
                            <td colSpan={5}><div className="empty-records"><span>Records not found</span></div></td>
                        </tr>
                    }
                    {
                        loading && <TableLoader colspan={5}/>
                    }
                </tbody>
            </table>
            <TableFoot  filter={filter} setFilter={setFilter} count={total} />
            <AddNewAccount show={modals.createAccount} setShow={setModals} formData={formData} action={action} setFormData={setFormData} setNotification={setNotification} setReRender={setReRender}/>
            <DialogModal show={dialog.show} setShow={() => setDialog((prev) => ({...prev, show: false}))} title={dialog.title} text={dialog.text} onSubmit={handlers.removeAccount} loader={dialog.loader} />
        </div>
    )
}

export default Accounts